<!-------------------------------------- Page Layout ---------------------------------------------->
<div class="container">
  <!-------------------------------------- Page Title ---------------------------------------------->
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-file-excel" aria-hidden="true"></i></span>{{ 'AdvisingAbnormal.Header' | translate }}
  </h1>

  <!-------------------------------------- Desktop Layout ---------------------------------------------->
  <p-card *ngIf="isInDesktopMode(); else mobileLayout">
    <ng-content *ngTemplateOutlet="desktopContent"></ng-content>
  </p-card>

  <!-------------------------------------- Mobile Layout ---------------------------------------------->
  <ng-template #mobileLayout>
    <p-card *ngIf="!isInDesktopMode()">
      <ng-content *ngTemplateOutlet="mobileContent"></ng-content>
    </p-card>
  </ng-template>

</div>

<!-------------------------------------- Desktop Content ---------------------------------------------->
<ng-template #desktopContent>
  <p-accordion [multiple]="true">

    <!-------------------------------------- Query Form ---------------------------------------------->
    <p-accordionTab
      header="{{ 'Common.Form.Header' | translate }}"
      [(selected)]="isSearchFormOpen"
    >
      <ng-content *ngTemplateOutlet="queryFormTemplate"></ng-content>
    </p-accordionTab>

    <!-------------------------------------- Header Table ---------------------------------------------->
    <p-accordionTab
      header="{{ 'AdvisingAbnormal.Table.Header.Header' | translate }}"
      [(selected)]="isHeaderTableOpen"
    >
      <ng-content *ngTemplateOutlet="headerTableTemplate"></ng-content>
    </p-accordionTab>

    <!-------------------------------------- Detail Table ---------------------------------------------->
    <p-accordionTab
      header="{{ 'AdvisingAbnormal.Table.Detail.Header' | translate }}"
      [(selected)]="isDetailTableOpen"
    >
      <ng-content *ngTemplateOutlet="detailTableTemplate"></ng-content>
    </p-accordionTab>

    <!-------------------------------------- Abnormal Item Table ---------------------------------------------->
    <p-accordionTab
      header="{{ 'AdvisingAbnormal.Table.AbnormalItem.Header' | translate }}"
      [(selected)]="isAbnormalItemTableOpen"
    >
      <ng-content *ngTemplateOutlet="abnormalItemTableTemplate"></ng-content>
    </p-accordionTab>

  </p-accordion>
</ng-template>

<!-------------------------------------- Mobile Content ---------------------------------------------->
<ng-template #mobileContent>
  <p-tabView [(activeIndex)]="mobileTabPanelActiveIndex">
    <!-------------------------------------- Query Form ---------------------------------------------->
    <p-tabPanel
      header="{{ 'Common.Form.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="queryFormTemplate"></ng-content>
    </p-tabPanel>

    <!-------------------------------------- Header Table ---------------------------------------------->
    <p-tabPanel
      header="{{ 'AdvisingAbnormal.Table.Header.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="headerTableTemplate"></ng-content>
    </p-tabPanel>

    <!-------------------------------------- Detail Table ---------------------------------------------->
    <p-tabPanel
      header="{{ 'AdvisingAbnormal.Table.Detail.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="detailTableTemplate"></ng-content>
    </p-tabPanel>

    <!-------------------------------------- Abnormal Item Table ---------------------------------------------->
    <p-tabPanel
      header="{{ 'AdvisingAbnormal.Table.AbnormalItem.Header' | translate }}"
    >
      <ng-content *ngTemplateOutlet="abnormalItemTableTemplate"></ng-content>
    </p-tabPanel>
  </p-tabView>
</ng-template>

<!-------------------------------------- Query Form ---------------------------------------------->
<ng-template #queryFormTemplate>
  <form
    [formGroup]="searchFormGroup"
  >

    <!-------------------------------------- Form Field ---------------------------------------------->
    <div class="p-fluid formgrid grid">
      <!-------------------------------------- Order Type Field ---------------------------------------------->
      <div class="field col-12">
        <h3 for="formOrderQueryScope">{{ 'AdvisingAbnormal.Form.Field.OrderQueryScope' | translate }}</h3>
        <div class="formgroup-inline">
          <div class="field-checkbox">
            <p-radioButton
              inputId="formOrderQueryScope"
              name="orderQueryScope"
              [value]="OrderQueryScopeEnum.personal"
              label="{{ 'AdvisingAbnormal.Form.RadioButton.PersonalOrder' | translate }}"
              formControlName="orderQueryScope"
            ></p-radioButton>
          </div>
          <div class="field-checkbox">
            <p-radioButton
              inputId="formOrderQueryScope"
              name="orderQueryScope"
              [value]="OrderQueryScopeEnum.includeDepartment"
              label="{{ 'AdvisingAbnormal.Form.RadioButton.IncludeDepartmentOrder' | translate }}"
              formControlName="orderQueryScope"
            ></p-radioButton>
          </div>
        </div>
      </div>

      <!-------------------------------------- Facility Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formFacility">{{ 'AdvisingAbnormal.Form.Field.Facility' | translate }}</label>
        <laas-facility-dropdown
          [isMultiple]="true"
          [showFilter]="true"
          [showToggleAll]="true"
          formControlName="facility"
        ></laas-facility-dropdown>
      </div>

      <!-------------------------------------- PCSR Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formFacility">{{ 'AdvisingAbnormal.Form.Field.Creater' | translate }}</label>
        <p-multiSelect
          appendTo="body"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          formControlName="pcsrAndCsrList"
          [options]="pcsrAndCsrOptions"
        ></p-multiSelect>
      </div>

      <!-------------------------------------- Vendor Number Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formVendorNumber">{{ 'AdvisingAbnormal.Form.Field.VendorNumber' | translate }}</label>
        <p-multiSelect
          inputId="formVendorNumber"
          appendTo="body"
          placeholder="{{ 'AdvisingAbnormal.Form.Placeholder.OptionHint.SelectOneOrMoreVendorNumber' | translate }}"
          formControlName="vendorNumber"
          [showToggleAll]="false"
          [virtualScroll]="true"
          [itemSize]="40"
          [styleClass]="checkRequiredField() ?  'p-invalid' : ''"
          [options]="vendorNumberOptions"
        ></p-multiSelect>
      </div>

      <!-------------------------------------- Hawb No Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formHawbNo">{{ 'AdvisingAbnormal.Form.Field.HawbNo' | translate }}</label>
        <p-chips #hawbNoChips
          inputId="formHawbNo"
          formControlName="hawbNo"
          separator=","
          [addOnTab]="true"
          (input)="addItemByComma($event, hawbNoChips)"
          [styleClass]="checkRequiredField() ? 'p-invalid' : ''"
          (onAdd)="hawbNoChipsAdd($event)"
        ></p-chips>
      </div>

      <!-------------------------------------- Ad No Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formAdNo">{{ 'AdvisingAbnormal.Form.Field.AdNo' | translate }}</label>
        <p-chips #adNoChips
          inputId="formAdNo"
          formControlName="adNo"
          separator=","
          [addOnTab]="true"
          (input)="addItemByComma($event, adNoChips)"
          [styleClass]="checkRequiredField() ? 'p-invalid' : ''"
          (onAdd)="adNoChipsAdd($event)"
        ></p-chips>
      </div>

      <!-------------------------------------- Invoice No Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formInvoiceNo">{{ 'AdvisingAbnormal.Form.Field.InvoiceNo' | translate }}</label>
        <p-chips #invoiceNoChips
          inputId="formInvoiceNo"
          formControlName="invoiceNo"
          separator=","
          [addOnTab]="true"
          (input)="addItemByComma($event, invoiceNoChips)"
          [styleClass]="checkRequiredField() ? 'p-invalid' : ''"
          (onAdd)="invoiceNoChipsAdd($event)"
        ></p-chips>
      </div>

      <!-------------------------------------- Notified Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formNotified">{{ 'AdvisingAbnormal.Form.Field.Notified' | translate }}</label>
        <p-dropdown
          appendTo="body"
          inputId="formNotified"
          placeholder="{{ 'AdvisingAbnormal.Form.Placeholder.OptionHint.SelectANotifyStatus' | translate }}"
          formControlName="notified"
          [showClear]="true"
          [options]="emailMarkOptions()"
        ></p-dropdown>

      </div>

      <!-------------------------------------- Replied Field ---------------------------------------------->
      <div class="field col-6">
        <label for="formReplied">{{ 'AdvisingAbnormal.Form.Field.Replied' | translate }}</label>
        <p-dropdown
          appendTo="body"
          inputId="formReplied"
          placeholder="{{ 'AdvisingAbnormal.Form.Placeholder.OptionHint.SelectAReplyStatus' | translate }}"
          formControlName="replied"
          [showClear]="true"
          [options]="emailMarkOptions()"
        ></p-dropdown>
      </div>

      <div class="field col-12">
        <small><strong class="p-invalid">
          {{ 'AdvisingAbnormal.Form.Warning.NotifiedAndRepliedWarning' | translate }}
        </strong></small>
      </div>

    </div>

    <!-------------------------------------- Form Button ---------------------------------------------->
    <div>

      <!-------------------------------------- Query Button ---------------------------------------------->
      <button pButton
        label="{{ 'Common.Button.Search' | translate }}"
        (click)="searchBtnClick()"
      ></button>

      <!-------------------------------------- Reset Button ---------------------------------------------->
      <button pButton
        label="{{ 'Common.Button.Reset' | translate }}"
        class="p-button-secondary ml-2"
        (click)="resetSearchForm()"
      ></button>

    </div>
  </form>
</ng-template>

<!-------------------------------------- Header Table ---------------------------------------------->
<ng-template #headerTableTemplate>
  <p-table #headerTable
    laasDataTableSetting
    class="datatable"
    [tableKey]="headerPreferenceKey"
    [defaultColumns]="columnGroupOfheaderTable()"
    (setPageSize)="setHeaderPageSize($event)"
    [value]="dataOfheaderTable"
    [selectable]="true"
    [loading]="isHeaderTableLoading"
    [resizableColumns]="true"
    [reorderableColumns]="true"

    [scrollable]="true"
    scrollHeight="500px"

    selectionMode="single"

    [lazy]="true"
    (onPage)="pagingOnHeaderTable($event)"
    (onSort)="sortingOnHeaderTable($event)"

    [paginator]="true"
    [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
    [showCurrentPageReport]="isInDesktopMode()"
    [showJumpToPageDropdown]="!isInDesktopMode()"
    [showPageLinks]="isInDesktopMode()"
    [showFirstLastIcon]="isInDesktopMode()"
    currentPageReportTemplate="{{ isInDesktopMode() ? ( 'Common.Table.PageSummary' | translate ) :  '{currentPage} of {totalPages}' }}"
    [rows]="this.pageInfoOfHeaderTable.pageSize"
    [rowsPerPageOptions]="this.rowsPerPageOptionsOfHeaderTable"
    [totalRecords]="this.pageInfoOfHeaderTable.totalRecords"

    [responsive]="true"
    dataKey="rownum"
    editMode="row"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
  >

    <!-------------------------------------- Header Table Caption Part ---------------------------------------------->
    <ng-template pTemplate="caption">
      <div class="caption flex flex-wrap justify-content-start">

        <!-------------------------------------- Header Table Display Columns Filter ---------------------------------------------->
        <div *ngIf="isInDesktopMode()">
          <laas-table-column-toggle
            [optionsColumn]="columnGroupOfheaderTable()"
            [dataTable]="headerTable">
          </laas-table-column-toggle>
        </div>

        <!-------------------------------------- Header Table Select All Button ---------------------------------------------->
        <div *ngIf="!isInDesktopMode()">
          <button pButton
            class="p-button-info p-button-raised"
            label="{{ 'AdvisingAbnormal.Table.Button.SelectAll' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            (click)="toggleAllRowCheckboxOnHeaderTable()"
          ></button>
        </div>

        <!-------------------------------------- Header Table Notify Button ---------------------------------------------->
        <laas-permission-button permissionCode="AdvisingAbnormalSendNotification"
          [class]="'p-button-success p-button-raised' + (!isInDesktopMode() ? '' : ' ml-2')"
          label="{{ 'AdvisingAbnormal.Table.Header.Button.Notify' | translate }}"
          [disabled]="!isAbleToSendMail()"
          (onClick)="askConfirmationForSendNotification()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Reply Button ---------------------------------------------->
        <laas-permission-button permissionCode="AdvisingAbnormalReplyNotification"
          [class]="'p-button-success p-button-raised' + (!isInDesktopMode() ? '' : ' ml-2')"
          label="{{ 'AdvisingAbnormal.Table.Header.Button.Reply' | translate }}"
          [disabled]="!isAbleToSendMail()"
          (onClick)="askConfirmationForReplyNotification()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Save Button ---------------------------------------------->
        <laas-permission-button permissionCode="AdvisingAbnormalEdit"
          [class]="'p-button-raised' + (!isInDesktopMode() ? '' : ' ml-2')"
          label="{{ 'Common.Button.Save' | translate }}"
          [disabled]="!isHeaderTableInEditMode"
          (onClick)="saveDataChangesOnHeaderTable()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Restore Button ---------------------------------------------->
        <laas-permission-button permissionCode="AdvisingAbnormalEdit"
          [class]="'p-button-secondary p-button-raised' + (!isInDesktopMode() ? '' : ' ml-2')"
          label="{{ 'AdvisingAbnormal.Table.Button.Restore' | translate }}"
          [disabled]="!isHeaderTableInEditMode"
          (onClick)="restoreDataOnHeaderTable()"
        ></laas-permission-button>

        <!-------------------------------------- Header Table Edit Button ---------------------------------------------->
        <laas-permission-button permissionCode="AdvisingAbnormalEdit"
          style="color: white;"
          [class]="'p-button-warning p-button-raised' + (!isInDesktopMode() ? '' : ' ml-2')"
          label="{{ isHeaderTableInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          [disabled]="!isAbleToEdit()"
          (onClick)="switchEditModeOnHeaderTable()"
        ></laas-permission-button>

      </div>
    </ng-template>

    <!-------------------------------------- Header Table Column Group Part ---------------------------------------------->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup *ngIf="isInDesktopMode()">
        <col style="width: 50px;">
        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
      </colgroup>
    </ng-template>

    <!-------------------------------------- Header Table Column Header Part ---------------------------------------------->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col">
          <p-checkbox
            #headerCheckboxOfHeaderTable
            (click)="toggleAllRowCheckboxOnHeaderTable()"
            [binary]="true">
          </p-checkbox>
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          scope="col"
          [attr.field]="col.field">
          <div class="flex">
            {{ col.header | translate }}
            <column-filter [tableColumn]="col"></column-filter>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <!-------------------------------------- Header Table Body Part ---------------------------------------------->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="selectRowOnHeaderTable(rowData)">
        <td *ngIf="isInDesktopMode()">
          <p-checkbox
            #rowCheckboxOfHeaderTable
            (click)="stopBubblingPhases($event)"
            (onChange)="toggleRowCheckboxOnHeaderTable($event, rowData)"
            [binary]="true">
          </p-checkbox>
        </td>
        <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

          <!-------------------------------------- Ad No Column ---------------------------------------------->
          <td *ngSwitchCase="'adNo'">
            <div class="tableDataTitle-responsive field flex justify-content-between" *ngIf="!isInDesktopMode()">
              <div class="pr-5 overflow-text">{{ col.header | translate }}</div>
              <p-checkbox
                #rowCheckboxOfHeaderTable
                (click)="stopBubblingPhases($event)"
                (onChange)="toggleRowCheckboxOnHeaderTable($event, rowData)"
                [binary]="true">
              </p-checkbox>
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Waiting Reference Column ---------------------------------------------->
          <td *ngSwitchCase="'waitingReference'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <p-dropdown
                  appendTo="body"
                  inputId="headerTableWaitingReference"
                  placeholder="{{ 'AdvisingAbnormal.Placeholder.OptionHint.SelectAWaitingReference' | translate }}"
                  [showClear]="true"
                  [filter]="true"
                  [options]="waitingReferenceOptionsOfHeaderTable"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                ></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text">
                  {{ getWaitingReferenceDescOfHeaderTableByItsCode(rowData[col.field]) | replaceNullWith: "-" }}
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!-------------------------------------- Doc Status Column ---------------------------------------------->
          <td *ngSwitchCase="'docStatus'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ getDocStatusDescByItsCode(rowData[col.field]) | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Notify Date Column ---------------------------------------------->
          <td *ngSwitchCase="'notifyDt'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Notify Flag Column ---------------------------------------------->
          <td *ngSwitchCase="'notifyFlag'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | optionsMapping: emailMarkOptions() | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Reply Flag Column ---------------------------------------------->
          <td *ngSwitchCase="'replyFlag'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | optionsMapping: emailMarkOptions() | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Reply Date Column ---------------------------------------------->
          <td *ngSwitchCase="'replyDt'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>
          <!-------------------------------------- Vendor Number Column ---------------------------------------------->
          <td *ngSwitchCase="'vendorNumber'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field]}}
            </div>
          </td>

          <td *ngSwitchDefault>
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

          <!-------------------------------------- Create Date Column ---------------------------------------------->
          <td *ngSwitchCase="'createDt'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>
        </ng-container>
      </tr>
      <br *ngIf="!isInDesktopMode()">
    </ng-template>


    <!-------------------------------------- Header Table Empty Message Part ---------------------------------------------->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td></td>
        <td [attr.colspan]="columns.length">
          {{ 'Common.Table.NoData' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>

<!-------------------------------------- Detail Table ---------------------------------------------->
<ng-template #detailTableTemplate>
  <p-table #detailTable
    laasDataTableSetting
    class="datatable"
    [tableKey]="detailPreferenceKey"
    [defaultColumns]="columnGroupOfDetailTable"
    (setPageSize)="setDetailPageSize($event)"
    [selectable]="true"
    [value]="dataOfDetailTable"
    [loading]="isDetailTableLoading"
    [resizableColumns]="true"
    [reorderableColumns]="true"

    [scrollable]="true"
    scrollHeight="500px"

    [(selection)]="selectedRowOfDetailTable"
    selectionMode="single"

    [lazy]="true"
    (onPage)="pagingOnDetailTable($event)"
    (onSort)="sortingOnDetailTable($event)"

    [paginator]="true"
    [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
    [showCurrentPageReport]="isInDesktopMode()"
    [showJumpToPageDropdown]="!isInDesktopMode()"
    [showPageLinks]="isInDesktopMode()"
    [showFirstLastIcon]="isInDesktopMode()"
    currentPageReportTemplate="{{ isInDesktopMode() ? ( 'Common.Table.PageSummary' | translate ) :  '{currentPage} of {totalPages}' }}"
    [rows]="this.pageInfoOfDetailTable.pageSize"
    [rowsPerPageOptions]="this.rowsPerPageOptionsOfDetailTable"
    [totalRecords]="this.pageInfoOfDetailTable.totalRecords"

    [responsive]="true"
    dataKey="dataKey"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
  >
    <!-------------------------------------- Detail Table Caption Part ---------------------------------------------->
    <ng-template pTemplate="caption">
      <div class="caption flex flex-wrap justify-content-start">

        <!-------------------------------------- Detail Table Display Columns Filter ---------------------------------------------->
        <div *ngIf="isInDesktopMode()">
          <laas-table-column-toggle
            [optionsColumn]="columnGroupOfDetailTable"
            [dataTable]="detailTable">
          </laas-table-column-toggle>
        </div>

        <!-------------------------------------- Detail Table Select All Button ---------------------------------------------->
        <div *ngIf="!isInDesktopMode()">
          <button pButton
            class="p-button-info p-button-raised"
            label="{{ 'AdvisingAbnormal.Table.Button.SelectAll' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            (click)="toggleAllRowCheckboxOnDetailTable()"
          ></button>
        </div>

        <!-------------------------------------- Detail Table Upload Button -------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.advisingAbnormalUpload)">
          <button pButton
            class="p-button-success p-button-raised"
            label="{{ 'AdvisingAbnormal.Table.Detail.Button.Upload' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbleToUpload()"
            (click)="showUploadFileDialog()"
          ></button>
        </div>

      </div>
    </ng-template>

    <!-------------------------------------- Detail Table Column Group Part ---------------------------------------------->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup *ngIf="isInDesktopMode()">
        <col style="width: 50px;">
        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
      </colgroup>
    </ng-template>

    <!-------------------------------------- Detail Table Column Header Part ---------------------------------------------->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col">
          <p-checkbox
            #headerCheckboxOfDetailTable
            (click)="toggleAllRowCheckboxOnDetailTable()"
            [binary]="true">
          </p-checkbox>
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          scope="col"
          [attr.field]="col.field">
          <div class="flex">
            {{ col.header | translate }}
            <column-filter [tableColumn]="col"></column-filter>
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <!------------------------------------------- Detail Table Body Part -------------------------------------------->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr
        (click)="selectRowOnDetailTable()"
        [pSelectableRow]="rowData"
        [style]="rowData.isRelated ?
          rowData == this.selectedRowOfDetailTable ? 'background-color: black; color: white;' : 'background-color: red; color: white;'
          : ''"
      >
        <td *ngIf="isInDesktopMode()">
          <p-checkbox
            #rowCheckboxOfDetailTable
            (click)="stopBubblingPhases($event)"
            (onChange)="toggleRowCheckboxOnDetailTable($event, rowData)"
            [binary]="true">
          </p-checkbox>
        </td>

        <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

          <!-------------------------------------- SKU Column ---------------------------------------------->
          <ng-container *ngIf="!isInDesktopMode()">
            <td *ngSwitchCase="'sku'">
              <div class="tableDataTitle-responsive field flex justify-content-between overflow-text">
                <div class="pr-5">{{ col.header | translate }}</div>
                <p-checkbox
                  #rowCheckboxOfDetailTable
                  (click)="stopBubblingPhases($event)"
                  (onChange)="toggleRowCheckboxOnDetailTable($event, rowData)"
                  [binary]="true">
                </p-checkbox>
              </div>
              <div class="tableData-responsive field overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </td>
          </ng-container>

          <td *ngSwitchCase="'receivedDt'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: "-" }}
            </div>
          </td>

          <td *ngSwitchDefault>
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

        </ng-container>
      </tr>
      <br *ngIf="!isInDesktopMode()">
    </ng-template>

    <!-------------------------------------- Detail Table Empty Message Part ---------------------------------------------->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td></td>
        <td [attr.colspan]="columns.length">
          {{ 'Common.Table.NoData' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>

<!-------------------------------------- Abnormal Item Table ---------------------------------------------->
<ng-template #abnormalItemTableTemplate>
  <p-table #abnormalItemTable
    laasDataTableSetting
    class="datatable"
    [tableKey]="abnormalItemPreferenceKey"
    [defaultColumns]="columnGroupOfAbnormalItemTable"
    (setPageSize)="setAbnormalItemPageSize($event)"
    [selectable]="true"
    [value]="dataOfAbnormalItemTable"
    [loading]="isAbnormalItemTableLoading"
    [resizableColumns]="true"
    [reorderableColumns]="true"

    [scrollable]="true"
    scrollHeight="500px"

    selectionMode="single"

    [lazy]="true"
    (onPage)="pagingOnAbnormalItemTable($event)"
    (onSort)="sortingOnAbnormalItemTable($event)"

    [paginator]="true"
    [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
    [showCurrentPageReport]="isInDesktopMode()"
    [showJumpToPageDropdown]="!isInDesktopMode()"
    [showPageLinks]="isInDesktopMode()"
    [showFirstLastIcon]="isInDesktopMode()"
    currentPageReportTemplate="{{ isInDesktopMode() ? ( 'Common.Table.PageSummary' | translate ) :  '{currentPage} of {totalPages}' }}"
    [rows]="this.pageInfoOfAbnormalItemTable.pageSize"
    [rowsPerPageOptions]="this.rowsPerPageOptionsOfAbnormalItemTable"
    [totalRecords]="this.pageInfoOfAbnormalItemTable.totalRecords"

    [responsive]="true"
    (onRowUnselect)="reselectAfterEnterKeyDown($event)"
    dataKey="dataKey"
    editMode="row"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
  >

    <!-------------------------------------- Abnormal Item Table Caption Part ---------------------------------------------->
    <ng-template pTemplate="caption">
      <div class="caption flex flex-wrap justify-content-start">

        <!-------------------------------------- Abnormal Item Table Display Columns Filter ---------------------------------------------->
        <div *ngIf="isInDesktopMode()">
          <laas-table-column-toggle
            [optionsColumn]="columnGroupOfAbnormalItemTable"
            [dataTable]="abnormalItemTable">
          </laas-table-column-toggle>
        </div>

        <!-------------------------------------- Abnormal Item Table Select All Button ---------------------------------------------->
        <div *ngIf="!isInDesktopMode()">
          <button pButton
            class="p-button-info p-button-raised"
            label="{{ 'AdvisingAbnormal.Table.Button.SelectAll' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            (click)="toggleAllRowCheckboxOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Add Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.advisingAbnormalEdit)">
          <button pButton *ngIf="isTenant"
            class="p-button-success p-button-raised"
            label="{{ 'Common.Button.Add' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || !this.selectedRowOfHeaderTable"
            (click)="addRowOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Delete Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.advisingAbnormalEdit)">
          <button pButton *ngIf="isTenant"
            class="p-button-danger p-button-raised"
            label="{{ 'Common.Button.Delete' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || dataOfAbnormalItemTable.length <= 0 || !this.selectedRowOfHeaderTable"
            (click)="deleteRowOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Save Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.advisingAbnormalEdit)">
          <button pButton
            class="p-button-raised"
            label="{{ 'Common.Button.Save' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || !this.selectedRowOfHeaderTable"
            (click)="saveDataChangesOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Restore Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.advisingAbnormalEdit)">
          <button pButton
            class="p-button-secondary p-button-raised"
            label="{{ 'AdvisingAbnormal.Table.Button.Restore' | translate }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbnormalItemTableInEditMode || !this.selectedRowOfHeaderTable"
            (click)="restoreDataOnAbnormalItemTable()"
          ></button>
        </div>

        <!-------------------------------------- Abnormal Item Table Edit Button ---------------------------------------------->
        <div *ngIf="this.permissionCodes.includes(this.advisingAbnormalEdit)">
          <button pButton
            style="color: white;"
            class="p-button-warning p-button-raised"
            label="{{ isAbnormalItemTableInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
            [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
            [disabled]="!isAbleToEdit()"
            (click)="switchEditModeOnAbnormalItemTable()"
          ></button>
        </div>

      </div>
    </ng-template>

    <!-------------------------------------- Abnormal Item Column Group Part ---------------------------------------------->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup *ngIf="isInDesktopMode()">
        <col style="width: 50px;">
        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
      </colgroup>
    </ng-template>

    <!-------------------------------------- Abnormal Item Table Column Header Part ---------------------------------------------->
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col">
          <p-checkbox
            #headerCheckboxOfAbnormalItemTable
            (click)="toggleAllRowCheckboxOnAbnormalItemTable()"
            [binary]="true">
          </p-checkbox>
        </th>
        <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          scope="col"
          [attr.field]="col.field">
          <div class="flex">
            {{ col.header | translate }}
            <column-filter [tableColumn]="col"></column-filter>
            <p-sortIcon [hidden]="!col.sort" [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <!------------------------------------------- Abnormal Item Table Body Part -------------------------------------------->
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="selectRowOnAbnormalItemTable(rowData)">
        <td *ngIf="isInDesktopMode()">
          <p-checkbox
            #rowCheckboxOfAbnormalItemTable
            (click)="stopBubblingPhases($event)"
            (onChange)="toggleRowCheckboxOnAbnormalItemTable($event, rowData)"
            [binary]="true">
          </p-checkbox>
        </td>
        <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

          <!------------------------------------------ Waiting Reference column --------------------------------------------------->
          <td *ngSwitchCase="'waitingReference'">
            <div class="tableDataTitle-responsive field flex justify-content-between overflow-text" *ngIf="!isInDesktopMode()">
              <div class="pr-5">{{ col.header | translate }}</div>
              <p-checkbox
                #rowCheckboxOfAbnormalItemTable
                (click)="stopBubblingPhases($event)"
                (onChange)="toggleRowCheckboxOnAbnormalItemTable($event, rowData)"
                [binary]="true">
              </p-checkbox>
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <p-dropdown
                  appendTo="body"
                  inputId="abnormalItemTableWaitingReference"
                  placeholder="{{ 'AdvisingAbnormal.Placeholder.OptionHint.SelectAWaitingReference' | translate }}"
                  [showClear]="true"
                  [filter]="true"
                  [options]="waitingReferenceOptionsOfAbnormalItemTable"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                ></p-dropdown>
                <small *ngIf="!rowData[col.field]" class="alert">
                  <div class="p-invalid">
                    {{ 'AdvisingAbnormal.Table.AbnormalItem.Toast.Warning.WaitingReferenceRequired' | translate }}
                  </div>
                </small>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text">
                  {{ getWaitingReferenceDescOfAbnormalItemTableByItsCode(rowData[col.field]) | replaceNullWith: "-" }}
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Waiting Reference Desc Column --------------------------------------------------->
          <td *ngSwitchCase="'waitingReferenceDesc'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableWaitingReferenceDesc"></label>
                <textarea pInputText
                  id="abnormalItemTableWaitingReferenceDesc"
                  rows="5"
                  cols="30"
                  maxlength="4000"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                >
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text" style="white-space: pre-line;">
                  <p style="word-break: break-all;">{{ rowData[col.field] | replaceNullWith: "-" }}</p>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Abnormal Case Count Column --------------------------------------------------->
          <td *ngSwitchCase="'abnormalCaseCnt'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableAbnormalCaseCnt"></label>
                <p-inputNumber
                  [useGrouping]="false"
                  [(ngModel)]="rowData[col.field]"
                ></p-inputNumber>
                <small *ngIf="rowData[col.field] < 0" class="alert">
                  <div class="p-invalid">
                    {{ 'AdvisingAbnormal.Table.AbnormalItem.Toast.Warning.NegativeAbnormalCaseCnt' | translate }}
                  </div>
                </small>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text">
                  {{ rowData[col.field] | replaceNullWith: "-" }}
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ File Column --------------------------------------------------->
          <td *ngSwitchCase="'file'">
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div  class="tableData-responsive field">
              <a *ngIf="rowData['docIds'] && rowData['docIds'].length > 0; else fileUpload"
                href="javascript: void(0);"
                (click)="showAbnormalItemFiles($event, rowData)"
              >
                {{ 'AdvisingAbnormal.Table.AbnormalItem.ColumnData.ShowFile' | translate }}
              </a>
              <ng-template #fileUpload>
                <a *ngIf="rowData.seqNo != -1; else emptyData"
                  href="javascript: void(0);"
                  (click)="showAbnormalItemFiles($event, rowData)"
                >
                  {{ 'AdvisingAbnormal.Table.AbnormalItem.ColumnData.Upload' | translate }}
                </a>
                <ng-template #emptyData>
                  -
                </ng-template>
              </ng-template>
            </div>
          </td>

          <!------------------------------------------ Handle Method Column --------------------------------------------------->
          <td *ngSwitchCase="'handleMethod'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableHandleMethod"></label>
                <textarea pInputText
                  id="abnormalItemTableHandleMethod"
                  rows="5"
                  cols="30"
                  maxlength="4000"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                >
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text" style="white-space: pre-line;">
                  <p style="word-break: break-all;">{{ rowData[col.field] | replaceNullWith: "-" }}</p>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Notes Column --------------------------------------------------->
          <td *ngSwitchCase="'notes'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableNotes"></label>
                <textarea pInputText
                  id="abnormalItemTableNotes"
                  rows="5"
                  cols="30"
                  maxlength="4000"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                >
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text" style="white-space: pre-line;">
                  <p style="word-break: break-all;">{{ rowData[col.field] | replaceNullWith: "-" }}</p>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>
          <!------------------------------------------ CreateUser Column --------------------------------------------------->
          <td *ngSwitchCase="'createUser'">
            <div class="tableDataTitle-responsive field">
              {{ col.header | translate }}
            </div>
            <p-cellEditor class="p-fluid">
              <ng-template pTemplate="input">
                <label for="abnormalItemTableCreateUser"></label>
                <textarea pInputText
                  id="abnormalItemTableCreateUser"
                  rows="5"
                  cols="30"
                  maxlength="4000"
                  (click)="stopBubblingPhases($event)"
                  [(ngModel)]="rowData[col.field]"
                >
                </textarea>
              </ng-template>
              <ng-template pTemplate="output">
                <div class="tableData-responsive field overflow-text" style="white-space: pre-line;">
                  <p style="word-break: break-all;">{{ rowData[col.field] | replaceNullWith: "-" }}</p>
                </div>
              </ng-template>
            </p-cellEditor>
          </td>

          <!------------------------------------------ Default Column --------------------------------------------------->
          <td *ngSwitchDefault>
            <div class="tableDataTitle-responsive field overflow-text">
              {{ col.header | translate }}
            </div>
            <div class="tableData-responsive field overflow-text">
              {{ rowData[col.field] | replaceNullWith: "-" }}
            </div>
          </td>

        </ng-container>
      </tr>
      <br *ngIf="!isInDesktopMode()">
    </ng-template>

    <!-------------------------------------- Abnormal Item Table Empty Message Part ---------------------------------------------->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td></td>
        <td [attr.colspan]="columns.length">
          {{ 'Common.Table.NoData' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</ng-template>

<!-------------------------------------- New Abnormal Item Dialog ---------------------------------------------->
<p-dialog #newAbnormalItemDialog
  header="{{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Header' | translate }}"
  appendTo="body"
  (visibleChange)="visibleChangeOfNewAbnormalItemDialog($event)"
  [modal]="true"
  [style]="{width: '70vw'}"
  [baseZIndex]="100"
  [draggable]="false"
  [maximizable]="true"
  [closeOnEscape]="false"
  [(visible)]="isShowNewAbnormalItemDialog"
>
  <div *ngIf="isNewAbnormalItemDialogLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="grid">

    <!-------------------------------------- Form ---------------------------------------------->
    <div class="col-6">
      <form
        [formGroup]="newAbnormalItemDialogFormGroup"
        (ngSubmit)="0"
      >
        <div class="p-fluid">
          <!-------------------------------------- Abnormal Case Count ---------------------------------------------->
          <div class="field">
            <h3
              for="dialogAbnormalCaseCount"
              [ngClass]="newAbnormalItemDialogFormGroup.value.abnormalCaseCnt >= 0 ? '' : 'p-invalid'"
            >
              {{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Form.Field.AbnormalCaseCount' | translate }}
            </h3>
            <p-inputNumber
              formControlName="abnormalCaseCnt"
              [useGrouping]="false"
            ></p-inputNumber>
            <small *ngIf="newAbnormalItemDialogFormGroup.value.abnormalCaseCnt < 0" class="alert">
              <div class="p-invalid">
                {{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Toast.Warning.NegativeAbnormalCaseCnt' | translate }}
              </div>
            </small>
          </div>
          <div class="field">
            <h3
              for="dialogWaitingReference"
              [ngClass]="newAbnormalItemDialogFormGroup.value.waitingReference ? '' : 'p-invalid'"
            >
              {{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Form.Field.WaitingReference' | translate }}
            </h3>
            <p-dropdown
              inputId="dialogWaitingReference"
              appendTo="body"
              placeholder="{{ 'AdvisingAbnormal.Placeholder.OptionHint.SelectAWaitingReference' | translate }}"
              formControlName="waitingReference"
              [showClear]="true"
              [filter]="true"
              [options]="waitingReferenceOptionsOfAbnormalItemTable"
              [baseZIndex]="1000"
            ></p-dropdown>
          </div>
          <div class="field">
            <h3>{{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Form.Field.WaitingReferenceDesc' | translate }}</h3>
            <label for="dialogWaitingReferenceDesc"></label>
            <textarea pInputTextarea
              id="dialogWaitingReferenceDesc"
              style="resize: none;"
              rows="7"
              formControlName="waitingReferenceDesc"
            ></textarea>
          </div>
        </div>
      </form>
    </div>

    <!-------------------------------------- File Table ---------------------------------------------->
    <div class="col-6">
      <h3>{{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.File.Header' | translate }}</h3>
      <label [ngClass]="'p-invalid'">{{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.File.Warn' | translate }}</label>
      <p-table #fileTable
        [columns]="columnGroupOfFileTable"
        [value]="dataOfFileTable"
        [resizableColumns]="true"
        [reorderableColumns]="true"

        [scrollable]="true"
        scrollHeight="500px"

        [paginator]="true"
        [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
        [showJumpToPageDropdown]="true"
        [showPageLinks]="false"
        [showFirstLastIcon]="isInDesktopMode()"
        [rows]="3"

        [responsive]="true"
        dataKey="dataKey"
        baseZIndex="1020"
        class="datatable"
        styleClass="p-datatable-sm p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
      >
        <!-------------------------------------- File Table Caption Part ---------------------------------------------->
        <ng-template pTemplate="caption">
          <div class="caption flex flex-wrap justify-content-start">

            <!-------------------------------------- Choose File Button -------------------------------------->
            <div>
              <label
                class="p-button p-component p-fileupload-choose"
              >
                <i *ngIf="isInDesktopMode()"class="pi pi-plus" aria-hidden="true" [ngClass]="'p-button-icon p-button-icon-left'"></i>
                {{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.File.Button.ChooseFile' | translate }}

                <input #newAbnormalItemfileInput
                  style="display:none"
                  type="file"
                  multiple="true"
                  (input)="onNewFileSelect(newAbnormalItemfileInput)"
                >
              </label>
            </div>
          </div>
        </ng-template>

        <!-------------------------------------- File Table Column Group Part ---------------------------------------------->
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup *ngIf="isInDesktopMode()">
            <col *ngFor="let col of columns" style="width: 15vw">
          </colgroup>
        </ng-template>

        <!-------------------------------------- File Table Column Header Part ---------------------------------------------->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              scope="col"
            >
              {{ col.header | translate }}
            </th>
          </tr>
        </ng-template>

        <!------------------------------------------- File Table Body Part -------------------------------------------->
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

              <!-------------------------------------- File Name Column ---------------------------------------------->
              <td *ngSwitchCase="'fileName'">
                <div class="tableDataTitle-responsive field flex justify-content-between" *ngIf="!isInDesktopMode()">
                  <div class="pr-5 overflow-text">{{ col.header | translate }}</div>
                  <button pButton
                    type="button"
                    icon="pi pi-times"
                    class="p-button-small p-button-rounded p-button-danger p-button-text"
                    (click)="removeChosenFile(rowIndex)"
                  ></button>
                </div>
                <div class="tableData-responsive field flex align-items-center">
                  <div *ngIf="isInDesktopMode()">
                    <button pButton
                      type="button"
                      icon="pi pi-times"
                      class="p-button-small p-button-rounded p-button-danger p-button-text"
                      (click)="removeChosenFile(rowIndex)"
                    ></button>
                  </div>
                  <div class="overflow-text">
                    {{ rowData['name'] | replaceNullWith: "-" }}
                  </div>
                </div>
              </td>
            </ng-container>
          </tr>
          <br *ngIf="!isInDesktopMode()">
        </ng-template>

        <!-------------------------------------- File Table Empty Message Part ---------------------------------------------->
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'Common.Table.NoData' | translate }}
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>
  </div>

  <!-------------------------------------- Related Detail Table ---------------------------------------------->
  <div>
    <h3>{{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.Header' | translate }}</h3>
    <p-table #relatedDetailTable
      [columns]="selectedColumnsOfRelatedDetailTable"
      [value]="dataOfRelatedDetailTable"
      [resizableColumns]="true"
      [reorderableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"

      [paginator]="true"
      [paginatorPosition]="isInDesktopMode() ? 'bottom': 'top'"
      [showJumpToPageDropdown]="!isInDesktopMode()"
      [showPageLinks]="isInDesktopMode()"
      [showFirstLastIcon]="isInDesktopMode()"
      [rows]="this.pageInfoOfDetailTable.pageSize"

      [responsive]="true"
      dataKey="dataKey"
      class="datatable"
      styleClass="p-datatable-sm p-datatable-gridlines p-datatable-stripped white-space: nowrap;"
    >
      <!-------------------------------------- Related Detail Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption" >
        <div class="caption">

          <!-------------------------------------- Related Detail Table Display Columns Filter ---------------------------------------------->
          <div *ngIf="isInDesktopMode()">
            <laas-table-column-toggle
              [optionsColumn]="columnGroupOfRelatedDetailTable"
              [dataTable]="relatedDetailTable">
            </laas-table-column-toggle>
          </div>

          <!-------------------------------------- Related Detail Table Select All Button ---------------------------------------------->
          <div *ngIf="!isInDesktopMode()">
            <button pButton
              class="p-button-info p-button-raised"
              label="{{ 'AdvisingAbnormal.Table.Button.SelectAll' | translate }}"
              [ngClass]="!isInDesktopMode() ? '' : 'p-button ml-2'"
              (click)="toggleAllRowCheckboxOnRelatedDetailTable()"
            ></button>
          </div>

        </div>
      </ng-template>

      <!-------------------------------------- Related Detail Table Column Group Part ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup *ngIf="isInDesktopMode()">
          <col style="width: 50px;">
          <col *ngFor="let col of columns" style="width: 15vw">
        </colgroup>
      </ng-template>

      <!-------------------------------------- Related Detail Table Column Header Part ---------------------------------------------->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">
            <p-checkbox
              #headerCheckboxOfRelatedDetailTable
              (click)="toggleAllRowCheckboxOnRelatedDetailTable()"
              [binary]="true">
            </p-checkbox>
          </th>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            scope="col"
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!------------------------------------------- Related Detail Table Body Part -------------------------------------------->
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>

          <td *ngIf="isInDesktopMode()">
            <p-checkbox
              #rowCheckboxOfRelatedDetailTable
              (click)="stopBubblingPhases($event)"
              (onChange)="toggleRowCheckboxOnRelatedDetailTable($event, rowData)"
              [binary]="true">
            </p-checkbox>
          </td>

          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- SKU Column ---------------------------------------------->
            <ng-container *ngIf="!isInDesktopMode()">
              <td *ngSwitchCase="'sku'">
                <div class="tableDataTitle-responsive field flex justify-content-between">
                  <div class="pr-5">{{ col.header | translate }}</div>
                  <p-checkbox
                    #rowCheckboxOfRelatedDetailTable
                    (click)="stopBubblingPhases($event)"
                    (onChange)="toggleRowCheckboxOnRelatedDetailTable($event, rowData)"
                    [binary]="true">
                  </p-checkbox>
                </div>
                <div class="tableData-responsive field overflow-text">
                  {{ rowData[col.field] | replaceNullWith: "-" }}
                </div>
              </td>
            </ng-container>

            <td *ngSwitchDefault>
              <div class="tableDataTitle-responsive field overflow-text">
                {{ col.header | translate }}
              </div>
              <div class="tableData-responsive field overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </td>

          </ng-container>
        </tr>
        <br *ngIf="!isInDesktopMode()">
      </ng-template>

      <!-------------------------------------- Related Detail Table Empty Message Part ---------------------------------------------->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td></td>
          <td [attr.colspan]="columns.length">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>

  <!--------------------------------------- Dialog Footer ---------------------------------------->
  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-raised mt-2"
      label="{{ 'Common.Button.Save' | translate }}"
      (click)="createNewAbnormalItem()"
    ></button>
  </ng-template>

</p-dialog>

<!-------------------------------------- Abnormal Item File Dialog ---------------------------------------------->
<p-dialog #abnormalItemFileDialog
  appendTo="body"
  (visibleChange)="visibleChangeOfAbnormalItemFileDialog($event)"
  [modal]="true"
  [style]="{width: '70vw'}"
  [baseZIndex]="100"
  [draggable]="false"
  [maximizable]="true"
  [closeOnEscape]="false"
  [(visible)]="isShowAbnormalItemFileDialog"
>

  <div *ngIf="isAbnormalItemFileDialogLoading" class="flex justify-content-center">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <ng-template pTemplate="header">
    <div class="text-2xl font-semibold">{{ 'AdvisingAbnormal.Dialog.AbnormalItemFile.Header' | translate }}</div>
    <label [ngClass]="'p-invalid'" style="margin-left: 30px;">{{ 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.File.Warn' | translate }}</label>
    <div class='abnormalItemFileDialogModeSwitch' >
      <p-radioButton
        class="mr-2"
        label="{{ 'AdvisingAbnormal.Dialog.AbnormalItemFile.Mode.Edit' | translate }}"
        name="abnormalItemFileDialogMode"
        [value]="ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Edit"
        [(ngModel)]="abnormalItemFileDialogMode">
      </p-radioButton>

      <p-radioButton
        label="{{ 'AdvisingAbnormal.Dialog.AbnormalItemFile.Mode.Download' | translate }}"
        name="abnormalItemFileDialogMode"
        [value]="ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Download"
        [(ngModel)]="abnormalItemFileDialogMode">
      </p-radioButton>
    </div>
    <div>
      <button class='p-dialog-header-icon' (click)="restoreAbnormalItemFileData()" pRipple>
        <span class="pi pi-refresh"></span>
      </button>
    </div>
  </ng-template>

  <div class="flex flex-wrap justify-content-start" *ngIf="!isAbnormalItemFileDialogLoading">

    <ng-container *ngIf="isAbnormalItemFileDialogInEditMode()">
      <label class='abnormal-item-file-add-btn' pRipple>
        <span class="pi pi-plus"></span>
        <input #abnormalItemFilefileInput
          style="display:none"
          type="file"
          multiple="true"
          (input)="addFileToAbnormalItem(abnormalItemFilefileInput)"
        >
      </label>
    </ng-container>

    <div *ngFor="let file of fileOfAbnormalItemFileDialog; let index = index">
      <div class="abnormal-item-file-block">

        <ng-container *ngIf="isAbnormalItemFileDialogInEditMode() else downloadModeTemplate">
          <img *ngIf="isImageTypeFile(file.fileType!); else editableFileIconTemplate"
            [alt]="file.fileName + '.' + file.fileExtension"
            [src]="transformToSafeUrl(file.fileDataUrl)"
            (click)="onFileClick(index)"
          />
          <ng-template #editableFileIconTemplate>
            <span class="abnormal-item-normal-file-icon pi pi-file-o"></span>
          </ng-template>

          <button *ngIf="filePermission" class='p-dialog-header-icon' (click)="deleteFileFromAbnormalItem(index)" pRipple>
            <span class="pi pi-times-circle"></span>
          </button>
        </ng-container>

        <ng-template #downloadModeTemplate>
          <a
            [href]="transformToSafeUrl(file.fileDataUrl)"
            [download]="file.fileName + '.' + file.fileExtension"
          >
            <span class="download-mask pi pi-download"></span>
          </a>

          <img *ngIf="isImageTypeFile(file.fileType!); else downloadableFileIconTemplate"
            [alt]="file.fileName + '.' + file.fileExtension"
            [src]="transformToSafeUrl(file.fileDataUrl)"
          />
          <ng-template #downloadableFileIconTemplate>
            <span class="abnormal-item-normal-file-icon pi pi-file-o"></span>
          </ng-template>

          <button *ngIf="filePermission" class='p-dialog-header-icon' (click)="deleteFileFromAbnormalItem(index)" pRipple>
            <span class="pi pi-times-circle"></span>
          </button>
        </ng-template>

      </div>

      <div class="abnormal-item-file-name-block">
        <p>{{file.fileName}}.{{file.fileExtension}}</p>
      </div>

    </div>

  </div>

  <p-galleria
    (visibleChange)="visibleChangeOfGalleria()"
    [value]="fileOfAbnormalItemFileDialog"
    [(activeIndex)]="indexOfGalleria"
    [containerStyle]="{'max-width': '80vw'}"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
    [baseZIndex]="1000"
    [transitionInterval]="0"
    [(visible)]="isShowBigFile"
  >
    <ng-template pTemplate="item" let-item>
        <img *ngIf="isImageTypeFile(item.fileType); else notImageFileTemplate"
          [src]="transformToSafeUrl(item.fileDataUrl)"
          [alt]="item.fileName + '.' + item.fileExtension"
          style="width: 100%; height: 100%; display: block;"
        />
        <ng-template #notImageFileTemplate>
          <span style="color: white">
            {{item.fileName + '.' + item.fileExtension}} is not a image file
          </span>
        </ng-template>
    </ng-template>
  </p-galleria>

  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-raised mt-2"
      label="{{ 'Common.Button.Save' | translate }}"
      [disabled]="!isAbleToSaveAbnormalItemFileChange()"
      (click)="onSaveBtnClickOnAbnormalItemFileDialog()"
    ></button>
  </ng-template>
</p-dialog>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
